export default "__VITE_ASSET__DCCQBhW___"